import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
export function Footer() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      desc: 'Private driver and airport transfer service in Ibiza. 24/7 transport for hotels, villas, beach clubs and events.',
      servicesTitle: 'Services',
      routesTitle: 'Popular Routes',
      contactTitle: 'Contact',
      services: [{
        name: 'Ibiza Airport Transfer',
        href: '/ibiza-airport-transfer'
      }, {
        name: 'Ibiza Villa Transfer',
        href: '/ibiza-villa-transfer'
      }, {
        name: 'Ibiza Night Driver',
        href: '/ibiza-night-driver'
      }, {
        name: 'Ibiza Group Transfer',
        href: '/ibiza-group-transfer'
      }],
      routes: [{
        name: 'Ibiza Airport to Ibiza Town',
        href: '/ibiza-airport-transfer#routes'
      }, {
        name: "Ibiza Airport to Playa d'en Bossa",
        href: '/ibiza-airport-transfer#routes'
      }, {
        name: 'Ibiza Airport to San Antonio',
        href: '/ibiza-airport-transfer#routes'
      }, {
        name: 'Ibiza Airport to Santa Eulalia',
        href: '/ibiza-airport-transfer#routes'
      }],
      location: 'Ibiza, Balearic Islands, Spain'
    },
    es: {
      desc: 'Servicio de chófer privado y traslados al aeropuerto en Ibiza. Transporte 24/7 para hoteles, villas, beach clubs y eventos.',
      servicesTitle: 'Servicios',
      routesTitle: 'Rutas Populares',
      contactTitle: 'Contacto',
      services: [{
        name: 'Transfer Aeropuerto Ibiza',
        href: '/ibiza-airport-transfer'
      }, {
        name: 'Transfer Villa Ibiza',
        href: '/ibiza-villa-transfer'
      }, {
        name: 'Chófer Nocturno Ibiza',
        href: '/ibiza-night-driver'
      }, {
        name: 'Transfer Grupo Ibiza',
        href: '/ibiza-group-transfer'
      }],
      routes: [{
        name: 'Aeropuerto Ibiza a Ibiza Ciudad',
        href: '/ibiza-airport-transfer#routes'
      }, {
        name: "Aeropuerto Ibiza a Playa d'en Bossa",
        href: '/ibiza-airport-transfer#routes'
      }, {
        name: 'Aeropuerto Ibiza a San Antonio',
        href: '/ibiza-airport-transfer#routes'
      }, {
        name: 'Aeropuerto Ibiza a Santa Eulalia',
        href: '/ibiza-airport-transfer#routes'
      }],
      location: 'Ibiza, Islas Baleares, España'
    }
  };
  const text = content[language];
  const currentYear = new Date().getFullYear();
  return <footer id="contact" className="bg-navy-light pt-10 md:pt-14 pb-8 border-t border-white/[0.06]" data-id="element-60">
      <div className="mx-auto max-w-7xl px-5" data-id="element-61">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-8 md:mb-10" data-id="element-62">
          {/* Brand */}
          <div className="md:col-span-3" data-id="element-63">
            <Link to="/" className="text-[0.8rem] font-heading text-white font-semibold tracking-[0.18em] uppercase block mb-4" data-id="element-64">
              Ibiza Private Drivers
            </Link>
            <p className="text-white/50 text-sm leading-relaxed max-w-sm" data-id="element-65">
              {text.desc}
            </p>
          </div>

          {/* Services */}
          <div className="md:col-span-3" data-id="element-66">
            <h3 className="text-white/80 text-xs font-semibold tracking-wider uppercase mb-4" data-id="element-67">
              {text.servicesTitle}
            </h3>
            <ul className="space-y-2.5" data-id="element-68">
              {text.services.map(link => <li key={link.name} data-id="element-69">
                  <Link to={link.href} className="text-white/45 hover:text-white/70 text-sm transition-colors" data-id="element-70">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Popular Routes */}
          <div className="md:col-span-3" data-id="element-71">
            <h3 className="text-white/80 text-xs font-semibold tracking-wider uppercase mb-4" data-id="element-72">
              {text.routesTitle}
            </h3>
            <ul className="space-y-2.5" data-id="element-73">
              {text.routes.map(link => <li key={link.name} data-id="element-74">
                  <Link to={link.href} className="text-white/45 hover:text-white/70 text-sm transition-colors" data-id="element-75">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3" data-id="element-76">
            <h3 className="text-white/80 text-xs font-semibold tracking-wider uppercase mb-4" data-id="element-77">
              {text.contactTitle}
            </h3>
            <ul className="space-y-2.5" data-id="element-78">
              <li data-id="element-79">
                <a href="tel:+34613756211" className="text-white/55 hover:text-white/80 text-sm transition-colors" data-id="element-80">
                  +34 613 756 211
                </a>
              </li>
              <li data-id="element-81">
                <a href="mailto:transferinibiza@gmail.com" className="text-white/45 hover:text-white/70 text-sm transition-colors" data-id="element-82">
                  transferinibiza@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-white/[0.06] flex flex-col md:flex-row items-center justify-between gap-3" data-id="element-83">
          <p className="text-white/30 text-xs" data-id="element-84">
            &copy; {currentYear} Ibiza Private Drivers
          </p>
          <p className="text-white/30 text-xs" data-id="element-85">{text.location}</p>
        </div>
      </div>
    </footer>;
}